import { render, staticRenderFns } from "./nipo-instructions.vue?vue&type=template&id=cb5b5cc4&scoped=true"
import script from "./nipo-instructions.vue?vue&type=script&lang=js"
export * from "./nipo-instructions.vue?vue&type=script&lang=js"
import style0 from "./nipo-instructions.vue?vue&type=style&index=0&id=cb5b5cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5b5cc4",
  null
  
)

export default component.exports